/**
 * TrendMart Flash Sale & Deal Countdown Timer
 */
document.addEventListener('DOMContentLoaded', () => {
  const initCountdowns = () => {
    const timers = document.querySelectorAll('[data-countdown-timer]');

    timers.forEach(timer => {
      let targetDateStr = timer.getAttribute('data-end-date');
      let targetTime;

      if (targetDateStr) {
        targetTime = new Date(targetDateStr).getTime();
      } else {
        // Fallback: 48 hours from now
        targetTime = new Date().getTime() + (48 * 60 * 60 * 1000);
      }

      const daysEl = timer.querySelector('[data-days]');
      const hoursEl = timer.querySelector('[data-hours]');
      const minsEl = timer.querySelector('[data-minutes]');
      const secsEl = timer.querySelector('[data-seconds]');

      const updateClock = () => {
        const now = new Date().getTime();
        const distance = targetTime - now;

        if (distance <= 0) {
          timer.innerHTML = '<span class="tm-badge" style="background:#EF4444;color:#fff;">DEAL ENDED</span>';
          clearInterval(interval);
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minsEl) minsEl.textContent = String(minutes).padStart(2, '0');
        if (secsEl) secsEl.textContent = String(seconds).padStart(2, '0');
      };

      updateClock();
      const interval = setInterval(updateClock, 1000);
    });
  };

  initCountdowns();
});
